var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeadset = function SvgIconHeadset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    fillRule: "evenodd",
    d: "M1.4 5.85A3.45 3.45 0 0 1 4.85 2.4h3.3a3.45 3.45 0 1 1 0 6.9h-3.3A3.45 3.45 0 0 1 1.4 5.85m3.45.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m4.05-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconHeadset;